import React from 'react';

const PostDifficulty = (props) => {
    const {
        term,
        icons
    } = props;

    let iconImage;

    icons.forEach(icon => {
        if (icon.id === term[0].id) {
            iconImage = icon.image
        }
    });

    let postDifficultyTag = <div className="cpt-post-difficulty">
        <figure dangerouslySetInnerHTML={{__html: iconImage}} />
        {term[0].name}
    </div>
    return postDifficultyTag;
}

export default PostDifficulty;